import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, ConselhosReducer, ConselhosState } from "./conselhos-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IConselhoPagedResponse } from "models/response/conselho-paged-response";

const ConselhosContext = createContext<ConselhosState | undefined>(undefined);
const ConselhosContextDispatchContext = createContext({} as any);

const ConselhosProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ConselhosReducer, {
        conselhos: new PaginationResponse<IConselhoPagedResponse>([], 0, 1, 10, 0),
        conselhoPagedRequest: { page: 0, pageSize: 10 },
        areas: [],
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as ConselhosState);

    return (
        <ConselhosContext.Provider value={state}>
            <ConselhosContextDispatchContext.Provider value={dispatch}>
                {children}
            </ConselhosContextDispatchContext.Provider>
        </ConselhosContext.Provider>
    );
}

const useConselhosState = () => {
    const context = useContext(ConselhosContext);
    if (context === undefined) {
        throw new Error('useConselhosState must be used within a ConselhosProvider');
    }
    return context;
}

const useConselhosDispatch = () => {
    const context = useContext(ConselhosContextDispatchContext);
    if (context === undefined) {
        throw new Error('useConselhosDispatch must be used within a ConselhosProvider');
    }
    return context;
}

export { ConselhosProvider, useConselhosState, useConselhosDispatch, ACTION_TYPES };
